export const sanityConfig = {
  projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'mo77qf3s',
  dataset: process.env.GATSBY_SANITY_DATASET || 'production',
};
